import { render, staticRenderFns } from "./AddressEdit.vue?vue&type=template&id=54923a00&scoped=true&"
import script from "./AddressEdit.vue?vue&type=script&lang=ts&"
export * from "./AddressEdit.vue?vue&type=script&lang=ts&"
import style0 from "./AddressEdit.vue?vue&type=style&index=0&id=54923a00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54923a00",
  null
  
)

export default component.exports